<div class="display-flex flex-align-center justify-content avatar" [ngStyle]="{
    width: size + 'px',
    height: size + 'px',
    fontSize: (size - 10) + 'px',
    backgroundColor: color
  }">
  <div>{{ name && name[0].toUpperCase() }}</div>
</div>
